import type { TemplateRenderer } from '../../types';
import { DateRangePicker } from './DateRangePicker';
import { expandAndGroupByMonth } from './group';
import { Page } from './Page';
import { getPageIndexForDate } from './pageIndex';
import { paginate } from './paginate';
import type { PageData } from './types';

export const plannerMonthRenderer: TemplateRenderer<PageData> = {
  DateRangePicker,
  Page,
  group: expandAndGroupByMonth,
  paginate,
  getPageIndexForDate,
};
